import CarrouselStyle from "./style.module.scss";

type IndicatorsProps = {
  contChildrens: number;
  tab: number;
  setTab: React.Dispatch<React.SetStateAction<number>>;
};

const BTNTabsIndicators: React.FC<IndicatorsProps> = ({
  contChildrens,
  tab,
  setTab
}) => {
  const btns = [];
  for (let i = 0; i < contChildrens; i++) {
    btns.push(
      <button
        key={i}
        className={`border btn ${
          i == tab ? "btn-light border-secondary" : "btn-secondary border-light"
        } my-2 mx-1 px-4`}
        onClick={() => setTab(i)}></button>
    );
  }
  return (
    <div
      title='tabs-indicators'
      className={`${CarrouselStyle.indicatorsContainer} `}>
      {btns}
    </div>
  );
};

export default BTNTabsIndicators;
